module.exports = {"confirm":"확인","cancel":"취소","save":"저장","delete":"삭제","edit":"수정","register":"등록","search":"검색","close":"닫기","all":"전체","select":"선택","list":"목록","download":"다운로드","hole":"홀","course":"코스","golfClub":"골프클럽","weekdays":["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],"everyWeek":"매주 {day}","everyMonth":"매월 {week}번 째 {day}"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/common.json
// module id = Ea/O
// module chunks = 2